import React from 'react';
import { IPointOfSaleSettingsProps } from 'components/settings/PointOfSaleSettings';
import { SettingDisplayText } from 'components/settings/SettingDisplayText';
import { SettingDisplayPassword } from 'components/settings/SettingDisplayPassword';
import { SettingDisplayDictionary } from 'components/settings/SettingDisplayDictionary';
import { OrderScenarioLabels } from 'components/order/model/Order';

const toScenarioEntries = (record?: Record<string, string>) =>
    Object.entries(record ?? {}).map(([key, value]) => ({
        label: OrderScenarioLabels[key] ?? key,
        value
    }));

export const ToastSettingsDisplay: React.FC<IPointOfSaleSettingsProps> = ({ settings, locationId }) => {
    const toast = settings?.toast;
    return (
        <>
            {/* Global Only */}
            {locationId === undefined && (
                <>
                    <SettingDisplayText title="Host" text={toast?.host} />
                    <SettingDisplayText title="Client ID" text={toast?.clientId} />
                    <SettingDisplayPassword title="Client Secret" text={toast?.clientSecret} />
                </>
            )}

            {/* Location Only */}
            {locationId !== undefined && (
                <>
                    <SettingDisplayText title="Restaurant GUID" text={toast?.restaurantGuid} />
                    <SettingDisplayText title="Payment Type GUID" text={toast?.paymentTypeGuid} />

                    <SettingDisplayDictionary
                        title="Dining Option Mapping"
                        entries={toScenarioEntries(toast?.scenarioToDiningOptionGuid)}
                    />
                    <SettingDisplayDictionary
                        title="Charge Mapping"
                        entries={toScenarioEntries(toast?.scenarioToChargeGuid)}
                    />
                    <SettingDisplayDictionary
                        title="Revenue Center Mapping"
                        entries={toScenarioEntries(toast?.scenarioToRevenueCenterGuid)}
                    />
                </>
            )}
        </>
    );
};
